import { postAPI } from "../../../../../API/ApiService";
import { BASE_URL } from "../../../../../constant/apiUrl";
export async function handleMultiSelectChange({
  value,
  setState,
  fieldName,
  onFieldChange,
  setCountryState,
  setLoading,
}) {
  if (Array.isArray(value) && value.length > 0) {
    setState(value); // store full object array
    onFieldChange(fieldName, value); // send full objects

    if (fieldName === "sectorId") {
      const sectorIds = value.map((item) => item.id);
      const response = await handleSectoryCountry(sectorIds, setLoading);
      if (typeof setCountryState === "function") {
        setCountryState(response?.response || []);
      }
    }
  } else {
    setState([]);
    onFieldChange(fieldName, []);

    if (fieldName === "sectorId" && typeof setCountryState === "function") {
      setCountryState([]);
    }
  }
}

export const handleSingleSelectChange = ({
  value,
  setState,
  fieldName,
  onFieldChange,
}) => {
  if (Array.isArray(value) && value.length > 0) {
    const selectedObj = value[0];
    setState(selectedObj); // 👈 Set object directly
    onFieldChange(fieldName, selectedObj); // 👈 Return full object instead of ID
  } else {
    setState([]); // 👈 Or [] if you want
    onFieldChange(fieldName, null);
  }
};

export const handleSectoryCountry = async (value, setLoading) => {
  setLoading(true);
  try {
    const response = await postAPI(
      `${BASE_URL}/lookup/find-countries-by-sectors`,
      value
    );
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (e) {
    console.log(e);
  } finally {
    setLoading(false);
  }
};

export function transformAssociatedItems(items) {
  return items.map((item) => ({
    ...item,
    description: item.summary,
    uploadedOn: item.createdDate,
    views: item.viewCount,
    likes: item.likeCount,
    thumbnailFileId: item.thumbnailId,
  }));
}
export async function autoPopulateFormFields({
  details,
  setValue,
  laguageFilter,
  sectorFilter,
  subjectFilter,
  disclaimers,
  setSelectedLanguage,
  setSelectedSectors,
  setCountryList,
  setSelectedSubjects,
  setDisclaimer,
  setLoading,
  setCountries,
  setKeyWords,
}) {
  // ✅ LANGUAGE (single-select)
  const lang = laguageFilter.find((item) => item.id === details?.languageId);
  if (lang) {
    const selectedLang = { id: lang?.id, displayText: lang?.name };

    setSelectedLanguage(selectedLang);
    setValue("languageId", selectedLang);
  }

  // ✅ SECTOR (multi-select)
  const sectors = details.sectorId
    ?.map((id) => {
      const match = sectorFilter.find((item) => item.id === id);
      return match ? { id: match?.id, displayText: match?.name } : null;
    })
    .filter(Boolean);

  if (sectors?.length) {
    setSelectedSectors(sectors);
    setValue("sectorId", sectors);

    // ✅ Fetch & set countries based on selected sectors
    try {
      const countryResponse = await handleSectoryCountry(
        sectors.map((s) => s.id),
        setLoading
      );
      const countryList = countryResponse?.response || [];
      setCountries(countryList);
      const selectedCountries = details.countryId
        ?.map((id) => {
          const match = countryList.find((item) => item.id === id);
          return match ? { id: match.id, displayText: match.name } : null;
        })
        .filter(Boolean);

      if (selectedCountries?.length) {
        setCountryList(selectedCountries);
        setValue("countryId", selectedCountries);
      }
    } catch (err) {
      console.error("Error fetching countries:", err);
    }
  }

  // ✅ SUBJECT (multi-select)
  const subjects = details?.subjectId
    ?.map((id) => {
      const match = subjectFilter.find((item) => item?.id === id);
      return match ? { id: match?.id, displayText: match?.name } : null;
    })
    .filter(Boolean);
  if (subjects?.length) {
    setSelectedSubjects(subjects);
    setValue("subjectId", subjects);
  }
  if (Array.isArray(details?.keywords) && details?.keywords?.length > 0) {
    const keywordString = details?.keywords.join(", ");
    setKeyWords(keywordString);
    setValue("keywords", keywordString);
  }
  // ✅ DISCLAIMER (single-select)
  const disc = disclaimers.find((item) => item.id === details?.disclaimerId);
  if (disc) {
    const selectedDisc = { id: disc?.id, displayText: disc?.name };
    setDisclaimer(selectedDisc);
    setValue("disclaimerId", disc);
  }
}

export const normalizeForumMedia = (forum) => {
  const transformArray = (arr = []) =>
    arr.map(({ subjects, ...rest }) => ({
      ...rest,
      ...(subjects !== undefined ? { subject: subjects } : {}),
    }));

  return {
    ...forum,
    documents: transformArray(forum.documents),
    links: transformArray(forum.links),
    videos: transformArray(forum.videos),
  };
};
